const columns = [
  {
    title: "站内导航",
    links: [
      { label: "热播剧演员表", href: "#cast" },
      { label: "主演阵容档案", href: "#actors" },
      { label: "收视与热度榜", href: "#ranking" },
      { label: "荧幕CP盘点", href: "#couples" },
    ],
  },
  {
    title: "戏外动态",
    links: [
      { label: "明星绯闻时间线", href: "#gossip" },
      { label: "幕后花絮精选", href: "#bts" },
      { label: "观众热评", href: "#reviews" },
      { label: "追剧问答", href: "#faq" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "内容说明", href: "#about" },
      { label: "使用指南", href: "#faq" },
      { label: "免责声明", href: "#about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-play-circle-fill text-lg"></i>
            </span>
            <span className="font-heading font-bold text-lg text-background-50">韩剧TV</span>
          </div>
          <p className="text-sm leading-relaxed text-secondary-300 max-w-xs">
            聚合热播剧的演员表与主演阵容，跟进明星绯闻动态与幕后花絮，帮追剧的你从角色一路看到本人。
          </p>
          <div className="flex items-center gap-2 mt-5">
            {["ri-weibo-line", "ri-message-3-line", "ri-play-circle-line", "ri-camera-lens-line"].map(
              (icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-md bg-secondary-900 text-secondary-200 flex items-center justify-center"
                >
                  <i className={icon}></i>
                </span>
              )
            )}
          </div>
        </div>

        {columns.map((col) => (
          <div key={col.title}>
            <h4 className="font-heading font-semibold text-background-50 mb-4">{col.title}</h4>
            <ul className="space-y-2.5">
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-secondary-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-secondary-800">
        <div id="about" className="w-full px-4 md:px-8 py-6 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-400 leading-relaxed max-w-2xl">
            本站为内容资讯演示站点，站内剧集、人物及相关动态均为策划性演示内容，绯闻与花絮以「已确认 / 媒体报道 / 传闻」等来源层级分别标注，请以官方信息为准。
          </p>
          <p className="text-xs text-secondary-400 whitespace-nowrap">
            © 2025 韩剧TV · 演员表档案
          </p>
        </div>
      </div>
    </footer>
  );
}